import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Profile from "../../assets/img/profile/profile.jpeg";
import Button from "react-bootstrap/Button";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
import "./About.css";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import HomeIcon from "@material-ui/icons/Home";
import DraftsIcon from "@material-ui/icons/Drafts";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
    color: "#212529",
    "&:hover": {
      color: "#616c77",
    },
  },
}));

const About: React.FC = () => {
  const classes = useStyles();
  return (
    <section id="about">
      <div className="about">
        <h1 className="pt-3 text-center font-details-b pb-3">About me</h1>
        <Container>
          <Row className="pt-3 pb-5 align-items-center">
            <Col xs={12} md={6} className="profile align-items-center mb-4">
              <Image
                className="profile justify-content-end"
                alt="profile"
                src={Profile}
                roundedCircle
                fluid
              />
              <div className="col m-2 mt-5 align-items-center contact__info">
                <p>
                  <HomeIcon /> Sabadell, Barcelona
                </p>
                <p>
                  <DraftsIcon /> gemma1030@gmail.com
                </p>
              </div>{" "}
            </Col>
            {/* About me description*/}
            <Col xs={12} md={6} style={{ textAlign: "justify" }} className="">
              <Row className="pb-4">
                {/* Description */}
                Hi there! I am <strong> &nbsp; Gemma Sanz Rabadán</strong>
                {"    "}
                <span role="img" aria-label="waving" className="emoji">
                  👋
                </span>
                <br /> A passionate developer and a Physiotherapist, born in
                Spain. I am a Full Stack Web Developer with experiente in
                React.js, Flux & Redux, Node.js, Express, and MongoDB as my
                favorite tech stack.
                <br />
                <br />I decided to change my life and switch from physical
                therapy to web development, I am passionate about helping
                people. I like challenges and being able to grow as part of a
                team.
              </Row>
              <Row className="justify-content-center">
                {/* <div className="d-flex row justify-content-center"> */}

                {/* </div> */}
                {/* Buttons */}
                <div className={classes.root}>
                  <a href="https://www.linkedin.com/in/gemma-sanz-rabadan/">
                    <LinkedInIcon className={classes.root} fontSize="large" />
                  </a>
                  <a href="https://github.com/gemmas95">
                    <GitHubIcon className={classes.root} fontSize="large" />
                  </a>{" "}
                </div>
                <div className="text-center">
                  <Link
                    to="/files/Gemma_Sanz_es_v01.pdf"
                    target="_blank"
                    download
                  >
                    <Button className="m-2" variant="outline-success">
                      Descargar CV en español{" "}
                    </Button>
                  </Link>

                  <Link
                    to="/files/Gemma_Sanz_en_v01.pdf"
                    target="_blank"
                    download
                  >
                    <Button className="m-2" variant="outline-success">
                      Download CV English Version{" "}
                    </Button>
                  </Link>
                </div>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};
export default About;
